import axios from 'axios';
import SETTINGS from '../settings'
export default {
    register(payload, cb, cbError) {
        axios.post(`${SETTINGS.API_BASE_PATH}/register`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            cbError(e)
        })
    },
    validateCode(payload, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/codevalidate`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            cb(e)
        })
    },
    validateSSOCode(payload, token, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/codevalidate`, payload, {
            headers: {
                Authorization: `Bearer ${ token }`,
            }
        }).then(response => {
            cb(response.data)
        }).catch(e => {
            cb(e)
        })
    },
    requestAccess(payload, cb, cbError) {
        axios.post(`${SETTINGS.API_BASE_PATH}/requestaccess`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            cbError(e)
        })
    }
}